import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import {
  HomeAboutComponent,
  HomeHerosectionComponent,
  HomeModelsComponent,
  HomeListingsComponent,
  HomeDifferenceComponent,
  HomeCtaComponent,
  TestimonialComponent,
  HomeAccountComponent,
} from '@out-web/components';
import { SeoService } from '@out-web/core';

@Component({
  selector: 'out-home',
  imports: [
    HomeHerosectionComponent,
    HomeAboutComponent,
    HomeModelsComponent,
    HomeListingsComponent,
    HomeDifferenceComponent,
    HomeCtaComponent,
    TestimonialComponent,
    HomeAccountComponent,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  constructor(private seoService: SeoService) { }

  ngOnInit(): void {
    this.setMetaData();
  }
  private setMetaData(): void {
    const title = 'Used Tesla For Sale | Only Used Tesla Marketplace';
    const description = 'Buy and Sell Used Teslas Easily | Browse our marketplace for affordable, certified pre-owned Tesla vehicles. Only Used Tesla - your trusted Tesla resale destination.';
    const imageUrl = 'https://onlyusedtesla.com/assets/images/meta-logo.png';
    const url = 'https://onlyusedtesla.com/';

    this.seoService.setMetaData(title, description, imageUrl, url);
  }
}
